import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setDate({ commit }, data) {
    commit(types.SET_DATE, data)
  },
  setView({ commit }, data) {
    commit(types.SET_VIEW, data)
  },
  setTechData({ commit }, data) {
    commit(types.SET_TECHDATA, data)
  },
  setData({ commit }, data) {
    commit(types.SET_DATA, data)
  },
  setTimeZone({ commit }, tz) {
    commit(types.SET_TIMEZONE, tz)
  },
  async getDashboard({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboard', () =>
      http.get('dashboard/dashboard', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD, r.data)
    return r.data
  },
  async getDashboardBreakout({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardBreakout', () =>
      http.get('dashboard/dashboardBreakout', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_BREAKOUT, r.data)
    return r.data
  },
  async getDashboardTop3({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardTop3', () =>
      http.get('dashboard/dashboardTop3', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_TOP3, r.data)
    return r.data
  },
  async getDashboardTop({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardTop3', () =>
      http.get('dashboard/dashboardTop', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_TOP, r.data)
    return r.data
  },
  async getDashboardProfit({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardProfit', () =>
      http.get('dashboard/dashboardProfit', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_PROFIT, r.data)
    return r.data
  },
  async getDashboardCycleTimes({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardCycleTimes', () =>
      http.get('dashboard/dashboardCycleTimes', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_CYCLETIMES, r.data)
    return r.data
  },
  async getDashboardTrend({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardTrend', () =>
      http.get('dashboard/dashboardTrend', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_TREND, r.data)
    return r.data
  },
  async getInvoices({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getInvoices', () =>
      http.get('data/invoicesExport', {
        params: data
      })
    )
    return r.data
  },
  async getInvoicesQuickBooks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getInvoicesQuickBooks', () =>
      http.get('data/invoicesExportQuickBooks', {
        params: data
      })
    )
    return r.data
  },
  async getTechnicianPayroll({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTechnicianPayroll', () =>
      http.get('dashboard/technicianPayroll', {
        params: data
      })
    )
    commit(types.SET_PAYROLL, r.data)
    return r.data
  },
  async getDashboardOpportunities({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDashboardOpportunities', () =>
      http.get('dashboard/dashboardOpportunities', {
        params: data
      })
    )
    commit(types.SET_OPPORTUNITIES, r.data)
    return r.data
  },
  async saveTechData({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTechData', () => http.post('user/saveTechData', data))
    // commit(types.SET_TECHDATA, r.data)
    return r.data
  },
  async getDashboardPayments({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDashboardPayments', () =>
      http.get('dashboard/dashboardPayments', {
        params: data
      })
    )
    commit(types.SET_PAYMENTS, r.data)
    return r.data
  },
  resetLog({ commit }) {
    commit(types.RESET_LOG)
  },
  setParameter({ commit }, data) {
    commit(types.SET_PARAMETER, data)
  },
  async getLog({ commit, dispatch }, data) {
    let r = null
    commit(types.RESET_LOG)
    let query = `query=Timestamp ge datetime'${data.startDate}' and Timestamp lt datetime'${data.endDate}'`
    r = await http.get(`log/queryLog?${query}`, {}, http.config, http.apiUrl)
    commit(types.SET_LOG, r.data)
    return r.data
  },
  filterLog({ commit }, data) {
    commit(types.FILTER_LOG, data)
  },
  async getCalibrateHistory({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrateHistory', () => http.get(`dashboard/calibrateHistory?calibrate=${id}`))
    commit(types.SET_HISTORY, r.data)
    return r.data
  },
  async getFragmentation({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getFragmentation', () => http.get('admin/getIndexFragmentation'))
    commit(types.SET_FRAGMENTATION, r.data)
    return r.data
  },
  async getMissingIndexes({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getMissingIndexes', () => http.get('admin/getMissingIndexes'))
    commit(types.SET_MISSING_INDEXES, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js